<input [class]="this.status" pInputText [formControl]="control" fieldSize="small" type="text" placeholder="Respuesta"
    [size]="size" />

<!-- [ngClass]="{ 'selected-radio': 'true']}" -->